import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
declare var process: any;
Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    redirect: '/Home'
  },
  {
    path: '/Home',
    name: 'Home',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Home.vue')
  },
  {
    path: '/Browse',
    name: 'Browse',
    component: () => import(/* webpackChunkName: "Browse" */ '../views/Browse.vue')
  },
  {
    path: '/Visualization/:id',
    name: 'Details',
    component: () => import(/* webpackChunkName: "Details" */ '../views/Details.vue')
  },
  {
    path: '/Visualization',
    name: 'Visualization',
    component: () => import(/* webpackChunkName: "Visualization" */ '../views/Visualization.vue')
  },
  {
    path: '/Tools',
    name: 'Tools',
    component: () => import(/* webpackChunkName: "Tools" */ '../views/Tools.vue')
  },
  {
    path: '/Help',
    name: 'Help',
    component: () => import(/* webpackChunkName: "Help" */ '../views/Help.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
